<div class="gp-wrap">

  <div class="gp-header">
    <div class="gp-subtitle">{{ 'PLANTILLAS.SUBTITLE' | translate }}</div>
    <button type="button" class="gp-btn gp-btn--primary" (click)="nuevo()">
      <mat-icon>add</mat-icon> {{ 'PLANTILLAS.NEW' | translate }}
    </button>
  </div>

  <!-- ===== Listado ===== -->
  <div *ngIf="!editing">
    <p *ngIf="loading" class="gp-muted">{{ 'COMMON.LOADING_ELLIPSIS' | translate }}</p>
    <div *ngIf="!loading" class="gp-table-wrapper">
    <table class="gp-table">
      <thead>
        <tr>
          <th>{{ 'PLANTILLAS.COL_NAME' | translate }}</th>
          <th>{{ 'PLANTILLAS.COL_DESC' | translate }}</th>
          <th>{{ 'PLANTILLAS.COL_STATUS' | translate }}</th>
          <th>{{ 'COMMON.ACTIONS' | translate }}</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let p of plantillas">
          <td>{{ p.nombre }}</td>
          <td class="gp-muted">{{ p.descripcion }}</td>
          <td>
            <span class="gp-badge" [class.gp-badge--on]="p.activo" [class.gp-badge--off]="!p.activo">
              {{ p.activo ? ('COMMON.ACTIVE_F' | translate) : ('COMMON.INACTIVE_F' | translate) }}
            </span>
          </td>
          <td class="gp-actions">
            <div class="em-actions-wrap">
              <button type="button" class="em-icon-btn" [matTooltip]="'COMMON.EDIT' | translate" matTooltipClass="em-tooltip" matTooltipPosition="left" (click)="editar(p)" [attr.aria-label]="'COMMON.EDIT' | translate">
                <mat-icon>edit</mat-icon>
              </button>
              <button type="button" class="em-icon-btn em-icon-btn--danger" [matTooltip]="'COMMON.DELETE' | translate" matTooltipClass="em-tooltip" matTooltipPosition="left" (click)="eliminar(p)" [attr.aria-label]="'COMMON.DELETE' | translate">
                <mat-icon>delete</mat-icon>
              </button>
            </div>
          </td>
        </tr>
        <tr *ngIf="plantillas.length === 0">
          <td colspan="4" class="gp-muted">{{ 'PLANTILLAS.EMPTY' | translate }}</td>
        </tr>
      </tbody>
    </table>
    </div>
  </div>

  <!-- ===== Editor ===== -->
  <div *ngIf="editing" class="gp-editor">
    <div class="gp-form">
      <div class="gp-field">
        <label>{{ 'PLANTILLAS.COL_NAME' | translate }}</label>
        <input type="text" [(ngModel)]="editing.nombre" maxlength="200" />
      </div>
      <div class="gp-field">
        <label>{{ 'PLANTILLAS.COL_DESC' | translate }}</label>
        <input type="text" [(ngModel)]="editing.descripcion" maxlength="500" />
      </div>
      <div class="gp-field gp-field--inline">
        <label class="fb-toggle">
          <input type="checkbox" [(ngModel)]="editing.activo" />
          <span class="fb-toggle__track"><span class="fb-toggle__thumb"></span></span>
          <span class="fb-toggle__text">{{ 'COMMON.ACTIVE_F' | translate }}</span>
        </label>
      </div>

      <div class="gp-field">
        <label>{{ 'PLANTILLAS.FIELDS' | translate }}</label>
        <div class="gp-chips">
          <button type="button" class="gp-chip" *ngFor="let c of campos" (click)="insertarCampo(c)">{{ c }}</button>
        </div>
        <small class="gp-muted">{{ 'PLANTILLAS.FIELDS_HINT' | translate }} <code>{{ '{{#if campo}}…{{/if}}' }}</code> <code>{{ '{{campo.CLAVE}}' }}</code></small>
      </div>

      <div class="gp-field">
        <label>{{ 'PLANTILLAS.HTML' | translate }}</label>
        <textarea class="gp-code" [(ngModel)]="editing.html" rows="18" spellcheck="false"></textarea>
      </div>

      <div class="gp-editor-actions">
        <button type="button" class="gp-btn gp-btn--ghost" (click)="cancelar()">{{ 'COMMON.CANCEL' | translate }}</button>
        <button type="button" class="gp-btn gp-btn--primary" (click)="guardar()">{{ 'COMMON.SAVE' | translate }}</button>
      </div>
    </div>

    <div class="gp-preview">
      <label>{{ 'PLANTILLAS.PREVIEW' | translate }}</label>
      <div class="gp-preview-box" [innerHTML]="preview"></div>
    </div>
  </div>

</div>
